export default function TheMovement() {
  return <section data-section-id="234169" id="seo-local" className="bg-background py-32 lg:py-60">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3 flex flex-col items-center text-center">
            {}
            <div className="w-50 h-px bg-primary mb-10" aria-hidden="true" />
            
            {}
            <p className="font-default text-lg md:text-xl lg:text-2xl text-muted-foreground leading-relaxed md:leading-relaxed lg:leading-relaxed">
              Nossa presença estratégica em <span className="font-default text-foreground font-semibold underline decoration-primary decoration-[2px] underline-offset-[6px] md:underline-offset-[8px]">Pinheiros e na Faria Lima</span> consolida nossa autoridade técnica em São Paulo. Atuamos no epicentro da inovação digital, transformando a complexidade tecnológica em narrativas de alto impacto que conectam marcas ao futuro do mercado brasileiro.
            </p>
          </div>
        </div>
      </div>
    </section>;
}